import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { SharedModule } from '../../../shared/shared.module';

import { PaymentGroupsService } from '../../../../services/payment/payment-groups.service';

import { PaymentDetailDialogComponent } from './payment-detail-dialog.component';
import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { ButtonModule } from '../../../shared/button/button.module';
import { SumPipeModule } from 'app/pipes/collection/sum.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        MatProgressSpinnerModule,
        ButtonModule,
        SumPipeModule,
    ],
    exports: [PaymentDetailDialogComponent],
    declarations: [PaymentDetailDialogComponent],
    providers: [
        // Pipes
        LegfiCurrencyPipe,
        LegfiDatePipe,

        // Services
        PaymentGroupsService,
    ],
})
export class PaymentDetailDialogModule
{
}
